import { WaitlistForm } from '@/features/public/waitlist/schemas/waitlistSchema.ts';
import { CreateWaitlistEntryDto } from '@/features/public/waitlist/types/CreateWaitlistEntryDto.ts';
import timeUtils from '@/utils/timeUtils.ts';

export const waitlistEntryDtoMapper = {
  fromFormToDto: (form: WaitlistForm): CreateWaitlistEntryDto => ({
    firstName: form.firstName,
    lastName: form.lastName,
    email: form.email,
    phoneNumber: form.phoneNumber,
    birthDate: timeUtils.toJavaDate(form.birthDate),
    participants: form.participants.map((p) => ({
      firstName: p.firstName,
      lastName: p.lastName,
      birthDate: timeUtils.toJavaDate(p.birthDate),
    })),
    note: form.note?.trim() || undefined,
  }),
};
